// removed by extract-text-webpack-plugin
module.exports = {"root":"App__root___3-5HS","app":"App__app___NghkZ","movingBackground":"App__movingBackground___1hp6i","overlays":"App__overlays___1Eayk","delayedAppear":"App__delayedAppear___2amiz","rotate360":"App__rotate360___S1Peu","shake-slow":"App__shake-slow___YrDYb","shakeSlow":"App__shake-slow___YrDYb"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 816
// module chunks = 0